/**
 * Created by Ning Jiang on 4/6/2017.
 */

import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Sine, TimelineLite, TweenLite} from "gsap";
import {EdisonParsedGameData} from "../server/data/EdisonParsedGameData";
import {EdisonGameModuleConfig} from "../EdisonGameModuleConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {Edison} from "../Edison";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {EdisonGameConfig} from "../EdisonGameConfig";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";

export class IndiSymWinHighlightPresentation extends WinPresentationController {
    private gameData: EdisonParsedGameData;

    constructor(indexes: [number, number]) {
        super(indexes, {
            name: "IndiSymWinHighlightPresentation",
            skippable: false
        });
    }

    protected hasWin(): boolean {
        return Edison.api.gameClientConfiguration.displayIndividualWinsInGame && this.gameData.betWaysOriginalData.length > 0;
    }

    protected addSingleBetWinAnimationToTimeline(betWayWinData: IBetWayWinData[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        betWayWinData.forEach((betWayWinData) => {
            const subTl = new TimelineLite();
            let winWaysCont: PIXI.Container;
            for (let i: number = 0; i < betWayWinData.reelWinPositions.length; i++) {
                for (let j: number = 0; j < betWayWinData.reelWinPositions[i].length; j++) {

                    if (betWayWinData.reelWinPositions[i][j]) {
                        // EdisonGameModuleConfig.winPresentationView.resetAnimations();
                        subTl.add(EdisonGameModuleConfig.individualWPView.playSPAnim(i, j), 0);
                    }
                    if (i === betWayWinData.length - 1 && j === betWayWinData.reelWinPositions[betWayWinData.length - 1].lastIndexOf(true)) {
                        winWaysCont = this.getWinWaysCont(betWayWinData);
                        subTl.add(() => {
                            StageManager.getLayer(EdisonGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name).addChild(winWaysCont);
                        })
                        subTl.add(TweenLite.fromTo(winWaysCont.position, 1,
                            {x: winWaysCont.position.x, y: winWaysCont.position.y},
                            {x: winWaysCont.position.x, y: winWaysCont.position.y - 30, ease: Sine.easeOut}));
                    }
                }
            }
            subTl.add(() => {
                StageManager.getLayer(EdisonGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name).removeChild(winWaysCont);
            })
            tl.add(subTl);
        })
        return tl;
    }

    protected parseFeatureGameData(data: EdisonParsedGameData): void {
        this.gameData = data
    }

    protected startWinPresentation(): void {
        const tl = new TimelineLite();
        tl.add(this.addSingleBetWinAnimationToTimeline(this.gameData.betWaysOriginalData));
        tl.add(() => {
            this.finish();
        })
    }

    protected stopWinPresentation(isAborted: boolean): void {
    }

    private getWinNumberText(betWayWinData: IBetWayWinData): string {
        let str: string = Currency.formatValue(betWayWinData.multipliedAmount);
        if (betWayWinData.multiplier > 1) {
            str += ` X ${betWayWinData.multiplier}`;
        }

        return str;
    }

    private getWinWaysCont(betWayWinData: IBetWayWinData): PIXI.Container {
        const cont: PIXI.Container = new PIXI.Container();
        const winNumber = new PIXI.BitmapText(this.getWinNumberText(betWayWinData), {
            fontName: "NumbersWinCountUp",
            fontSize: 45,
        });
        while (winNumber.width > GameConfig.instance.SYMBOL_WIDTH-10) {
            --winNumber.fontSize;
        }
        winNumber.pivot.set(winNumber.width/2,winNumber.height/2);

        const waysNumber= new PIXI.BitmapText(betWayWinData.numberOfCombinations + " ", {
            fontName: "WinWaysNumbers",
            fontSize: 30,
        });
        while (waysNumber.width > 50) {
            --waysNumber.fontSize;
        }
        waysNumber.pivot.set(waysNumber.width/2,waysNumber.height/2);

        const waysSprite:PIXI.Sprite=new PIXI.Sprite(GameResources.getTextures(betWayWinData.numberOfCombinations===1?"wayWonImage":"waysWonImage")[0]);
        waysSprite.anchor.set(0, 0.5);
        waysSprite.width=waysSprite.width/2;
        waysSprite.height=waysSprite.height/2;
        waysSprite.position.x=waysNumber.width;

        const winWaysCont:PIXI.Container = new PIXI.Container();
        winWaysCont.addChild(waysNumber,waysSprite);
        winWaysCont.position.set(-winNumber.width/3,30);


        cont.addChild(winNumber, winWaysCont);

        cont.position.set(Helper.getSymbolPositions(betWayWinData.length - 1, betWayWinData.reelWinPositions[betWayWinData.length - 1].lastIndexOf(true))[0],
            Helper.getSymbolPositions(betWayWinData.length - 1, betWayWinData.reelWinPositions[betWayWinData.length - 1].lastIndexOf(true))[1]);
        return cont;
    }
}